import React, { useState, useEffect } from 'react';
import ReportWidget from './ReportWidget';
import LoadingPage from '../LoadingPage';
import Chart from '../../util/chart';
import { convertToArrayOfObjects } from '../../util/report';

const WEBAP2Widget = () => {
  const [agingDetail, setAgingDetail] = useState(null);

  const renderCharts = () => {
    Chart.makePieChart('webap2-widget-chart-1', {
      titles: [
        {
          text: 'A/P Aging Breakdown',
        },
      ],
      dataProvider: agingDetail,
      balloonText: '<span style="font-size:14px">[[title]]<br><b>$[[value]]</b> ([[percents]])</span>',
    });
  };

  useEffect(() => {
    if (agingDetail) {
      renderCharts();
    }
  }, [agingDetail]);

  const handleData = ({ data, cols }) => {
    // transform array of positional data to array of json objects
    data = convertToArrayOfObjects(data, cols);

    let current = 0.0;
    let valueOver30 = 0.0;
    let valueOver60 = 0.0;
    let valueOver90 = 0.0;

    data.forEach(row => {
      const crrnt = parseFloat(row.crrnt);
      const overthirty = parseFloat(row.overthirty);
      const oversixty = parseFloat(row.oversixty);
      const overninety = parseFloat(row.overninety);

      current += !isNaN(crrnt) ? crrnt : 0.0;
      valueOver30 += !isNaN(overthirty) ? overthirty : 0.0;
      valueOver60 += !isNaN(oversixty) ? oversixty : 0.0;
      valueOver90 += !isNaN(overninety) ? overninety : 0.0;
    });

    setAgingDetail([
      { label: 'Current', value: current },
      { label: '> 30 Days', value: valueOver30 },
      { label: '> 60 Days', value: valueOver60 },
      { label: '> 90 Days', value: valueOver90 },
    ]);
  };

  return (
    <ReportWidget pageName="WEBAP2" reportOptions={['2']} handleData={handleData}>
      {agingDetail ? <div id="webap2-widget-chart-1" className="carousel-cell" /> : <LoadingPage />}
    </ReportWidget>
  );
};

export default WEBAP2Widget;
